export default "__VITE_PUBLIC_ASSET__03b10416__"